export default __webpack_public_path__ + "static/adventurer-9060ad91f3edffdd34c647975cdade06.png";